export const UPDATE_STOP_TRACKING_REASON = 'UPDATE_STOP_TRACKING_REASON';
export const UPDATE_STOP_TRACKING_END_DATE = 'UPDATE_STOP_TRACKING_END_DATE';
export const UPDATE_STOP_TRACKING_PREGNANCY_NOTES = 'UPDATE_STOP_TRACKING_PREGNANCY_NOTES';
export const UPDATE_STOP_TRACKING_CYCLE_TYPE = 'UPDATE_STOP_TRACKING_CYCLE_TYPE';
export const RESET_STOP_TRACKING = 'RESET_STOP_TRACKING';
export const COMPLETE_STOP_TRACKING = 'COMPLETE_STOP_TRACKING';
export const COMPLETE_STOP_TRACKING_START = 'COMPLETE_STOP_TRACKING_START';
export const COMPLETE_STOP_TRACKING_SUCCESS = 'COMPLETE_STOP_TRACKING_SUCCESS';
export const COMPLETE_STOP_TRACKING_ERROR = 'COMPLETE_STOP_TRACKING_ERROR';
export const TAKE_A_BREAK = 'TAKE_A_BREAK';
export const RESET_TAKE_A_BREAK = 'RESET_TAKE_A_BREAK';
export const TAKE_A_BREAK_START = 'TAKE_A_BREAK_START';
export const TAKE_A_BREAK_SUCCESS = 'TAKE_A_BREAK_SUCCESS';
export const TAKE_A_BREAK_ERROR = 'TAKE_A_BREAK_ERROR';
export const RESET_SETUP = 'RESET_SETUP';
export const UPDATE_SETUP_DUE_DATE = 'UPDATE_SETUP_DUE_DATE';
export const UPDATE_DAILY_HYDRATION_GOAL = 'UPDATE_DAILY_HYDRATION_GOAL';
export const UPDATE_WEIGHT_GOAL_USER_INPUTS = 'UPDATE_WEIGHT_GOAL_USER_INPUTS';
export const UPDATE_INDEX_SCALE_ADVANCED_METRICS = 'UPDATE_INDEX_SCALE_ADVANCED_METRICS';
export const ENABLE_MOVE_ALERTS = 'ENABLE_MOVE_ALERTS';
export const ENABLE_TRAINING_STATUS_ALERTS = 'ENABLE_TRAINING_STATUS_ALERTS';
export const INITIAL_PREGNANCY_CREATE = 'INITIAL_PREGNANCY_CREATE';
export const INITIAL_PREGNANCY_CREATE_SEND = 'INITIAL_PREGNANCY_CREATE_SEND';
export const INITIAL_PREGNANCY_CREATE_SUCCESS = 'INITIAL_PREGNANCY_CREATE_SUCCESS';
export const INITIAL_PREGNANCY_CREATE_ERROR = 'INITIAL_PREGNANCY_CREATE_ERROR';
export const INITIAL_PREGNANCY_HYDRATION_ERROR = 'INITIAL_PREGNANCY_HYDRATION_ERROR';
export const INITIAL_PREGNANCY_TRAINING_STATUS_ERROR = 'INITIAL_PREGNANCY_TRAINING_STATUS_ERROR';
export const INITIAL_PREGNANCY_WEIGHT_GAIN_GOALS_ERROR = 'INITIAL_PREGNANCY_WEIGHT_GAIN_GOALS_ERROR';
export const INITIAL_PREGNANCY_INDEX_SCALE_ERROR = 'INITIAL_PREGNANCY_INDEX_SCALE_ERROR';
export const INITIAL_PREGNANCY_MOVE_ALERT_ERROR = 'INITIAL_PREGNANCY_MOVE_ALERT_ERROR';
export const FETCH_PREGNANCY_SNAPSHOTS = 'FETCH_PREGNANCY_SNAPSHOTS';
export const FETCH_PREGNANCY_SNAPSHOTS_FETCHING = 'FETCH_PREGNANCY_SNAPSHOTS_FETCHING';
export const FETCH_PREGNANCY_SNAPSHOTS_SUCCESS = 'FETCH_PREGNANCY_SNAPSHOTS_SUCCESS';
export const FETCH_PREGNANCY_SNAPSHOTS_FAIL = 'FETCH_PREGNANCY_SNAPSHOTS_FAIL';
export const UPDATE_PREGNANCY_SNAPSHOT = 'UPDATE_PREGNANCY_SNAPSHOT';
export const UPDATE_PREGNANCY_SNAPSHOT_UPDATING = 'UPDATE_PREGNANCY_SNAPSHOT_UPDATING';
export const UPDATE_PREGNANCY_SNAPSHOT_SUCCESS = 'UPDATE_PREGNANCY_SNAPSHOT_SUCCESS';
export const UPDATE_PREGNANCY_SNAPSHOT_FAIL = 'UPDATE_PREGNANCY_SNAPSHOT_FAIL';
export const DELETE_PREGNANCY_SNAPSHOT = 'DELETE_PREGNANCY_SNAPSHOT';
export const FETCH_PREGNANCY_DAYVIEW = 'FETCH_PREGNANCY_DAYVIEW';
export const FETCH_PREGNANCY_DAYVIEW_FETCHING = 'FETCH_PREGNANCY_DAYVIEW_FETCHING';
export const FETCH_PREGNANCY_DAYVIEW_SUCCESS = 'FETCH_PREGNANCY_DAYVIEW_SUCCESS';
export const FETCH_PREGNANCY_DAYVIEW_FAIL = 'FETCH_PREGNANCY_DAYVIEW_FAIL';
export const UPDATE_PREGNANCY_DAILY_LOG = 'UPDATE_PREGNANCY_DAILY_LOG';
export const UPDATE_PREGNANCY_DAILY_LOG_SUCCESS = 'UPDATE_PREGNANCY_DAILY_LOG_SUCCESS';
export const UPDATE_PREGNANCY_DAILY_LOG_FAIL = 'UPDATE_PREGNANCY_DAILY_LOG_FAIL';
export const FETCH_PREGNANCY_GLUCOSE = 'FETCH_PREGNANCY_GLUCOSE';
export const FETCH_PREGNANCY_GLUCOSE_FETCHING = 'FETCH_PREGNANCY_GLUCOSE_FETCHING';
export const FETCH_PREGNANCY_GLUCOSE_SUCCESS = 'FETCH_PREGNANCY_GLUCOSE_SUCCESS';
export const FETCH_PREGNANCY_GLUCOSE_FAIL = 'FETCH_PREGNANCY_GLUCOSE_FAIL';
export const ADD_PREGNANCY_GLUCOSE = 'ADD_PREGNANCY_GLUCOSE';
export const ADD_PREGNANCY_GLUCOSE_SUCCESS = 'ADD_PREGNANCY_GLUCOSE_SUCCESS';
export const ADD_PREGNANCY_GLUCOSE_FAIL = 'ADD_PREGNANCY_GLUCOSE_FAIL';
export const UPDATE_PREGNANCY_GLUCOSE = 'UPDATE_PREGNANCY_GLUCOSE';
export const UPDATE_PREGNANCY_GLUCOSE_SUCCESS = 'UPDATE_PREGNANCY_GLUCOSE_SUCCESS';
export const UPDATE_PREGNANCY_GLUCOSE_FAIL = 'UPDATE_PREGNANCY_GLUCOSE_FAIL';
export const DELETE_PREGNANCY_GLUCOSE = 'DELETE_PREGNANCY_GLUCOSE';
export const DELETE_PREGNANCY_GLUCOSE_SUCCESS = 'DELETE_PREGNANCY_GLUCOSE_SUCCESS';
export const DELETE_PREGNANCY_GLUCOSE_FAIL = 'DELETE_PREGNANCY_GLUCOSE_FAIL';
export const FETCH_PREGNANCY_ICON = 'FETCH_PREGNANCY_ICON';
export const FETCH_PREGNANCY_ICON_SUCCESS = 'FETCH_PREGNANCY_ICON_SUCCESS';
export const FETCH_PREGNANCY_ICON_FAIL = 'FETCH_PREGNANCY_ICON_FAIL';
export const INITIAL_PREGNANCY_CREATE_CONFLICT_ERROR = 'INITIAL_PREGNANCY_CREATE_CONFLICT_ERROR';
export const FETCH_PREGNANCY_WEIGHT_GAIN_GOALS = 'FETCH_PREGNANCY_WEIGHT_GAIN_GOALS';
export const FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_FETCHING = 'FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_FETCHING';
export const FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_SUCCESS = 'FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_SUCCESS';
export const FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_FAIL = 'FETCH_PREGNANCY_WEIGHT_GAIN_GOALS_FAIL';

export function updateStopTrackingPregnancyNotes(notes) {
    return {
        type: UPDATE_STOP_TRACKING_PREGNANCY_NOTES,
        notes
    };
}

export function updateStopTrackingReason(reason) {
    return {
        type: UPDATE_STOP_TRACKING_REASON,
        reason
    };
}

export function updateStopTrackingEndDate(endDate) {
    return {
        type: UPDATE_STOP_TRACKING_END_DATE,
        endDate
    };
}

export function updateStopTrackingCycleType(cycleType) {
    return {
        type: UPDATE_STOP_TRACKING_CYCLE_TYPE,
        cycleType
    };
}

export function resetStopTracking() {
    return {
        type: RESET_STOP_TRACKING
    };
}

export function completeStopTracking(data) {
    return {
        type: COMPLETE_STOP_TRACKING,
        data
    };
}

export function resetTakeBreak() {
    return {
        type: RESET_TAKE_A_BREAK
    };
}

export function takeBreakFromTracking(data) {
    return {
        type: TAKE_A_BREAK,
        data
    };
}

export function resetSetup() {
    return {
        type: RESET_SETUP
    };
}

export function updateSetupDueDate(title, dueDate) {
    return {
        type: UPDATE_SETUP_DUE_DATE,
        dueDate: dueDate,
        title: title
    };
}

export function updateSetupDailyHydrationGoal(hydrationGoal) {
    return {
        type: UPDATE_DAILY_HYDRATION_GOAL,
        hydrationGoal
    };
}

export function updateSetupWeightGoalUserInputs(weightGoalUserInputs) {
    return {
        type: UPDATE_WEIGHT_GOAL_USER_INPUTS,
        weightGoalUserInputs
    };
}

export function updateSetupIndexScaleAdvancedMetrics(deviceId, advancedMetrics) {
    return {
        type: UPDATE_INDEX_SCALE_ADVANCED_METRICS,
        advancedMetrics: {
            deviceId: deviceId,
            advancedMetrics: advancedMetrics
        }
    };
}

export function updateSetupMoveAlerts(deviceId, enabled) {
    return {
        type: ENABLE_MOVE_ALERTS,
        deviceId: deviceId,
        enabled: enabled
    };
}

export function updateSetupTrainingStatusAlerts(enableTrainingStatusAlerts) {
    return {
        type: ENABLE_TRAINING_STATUS_ALERTS,
        enableTrainingStatusAlerts
    };
}

export function setupInitialPregnancy(setupDetail) {
    return {
        type: INITIAL_PREGNANCY_CREATE,
        setupDetail
    };
}

export function fetchPregnancySnapshots() {
    return { type: FETCH_PREGNANCY_SNAPSHOTS };
}

export function updatePregnancySnapshot(pregnancySettings, originalDueDate, callback) {
    return {
        type: UPDATE_PREGNANCY_SNAPSHOT,
        pregnancySettings: pregnancySettings,
        originalDueDate: originalDueDate,
        callback: callback
    };
}

export function deletePregnancySnapshot(originalDueDate, callback) {
    return {
        type: DELETE_PREGNANCY_SNAPSHOT,
        originalDueDate: originalDueDate,
        callback: callback
    };
}

export function fetchDayView(date, evictCache) {
    return {
        type: FETCH_PREGNANCY_DAYVIEW,
        date,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}

export function updateDailyLog(log) {
    return {
        type: UPDATE_PREGNANCY_DAILY_LOG,
        log
    };
}

export function fetchGlucose(date) {
    return {
        type: FETCH_PREGNANCY_GLUCOSE,
        date
    };
}

export function addGlucoseLog(log, reload = false) {
    return {
        type: ADD_PREGNANCY_GLUCOSE,
        message: {
            log,
            reload
        }
    };
}

export function updateGlucoseLog(log, reload = false) {
    return {
        type: UPDATE_PREGNANCY_GLUCOSE,
        message: {
            log,
            reload
        }
    };
}

export function deleteGlucoseLog(log, reload = false) {
    return {
        type: DELETE_PREGNANCY_GLUCOSE,
        message: {
            log,
            reload
        }
    };
}

export function fetchPregnancyIcon(iconKey) {
    return {
        type: FETCH_PREGNANCY_ICON,
        message: {
            iconKey
        }
    };
}

export function fetchPregnancyWeightGainGoals(date, evictCache) {
    return {
        type: FETCH_PREGNANCY_WEIGHT_GAIN_GOALS,
        date,
        meta: {
            cacheTime: evictCache ? null : 1000
        }
    };
}
